import { APITruck } from './truck.types';

export class APISupplier {
  id: number;
  name: string;
  contactInfo: string;
  address: string | null;
  phone: string | null;
  email: string | null;
  regularCarrier: boolean;
  createdAt: Date;
  updatedAt: Date;

  trucks: APITruck[];
  contacts: any[];

  constructor(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.contactInfo = data.contactInfo;
    this.address = data.address;
    this.phone = data.phone;
    this.email = data.email;
    this.regularCarrier = data.regularCarrier ?? false;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.trucks = data.trucks || [];
    this.contacts = data.contacts || [];
  }
}
